import { ReportReasonType } from "../Types/types";

export default class ReportModel {
  public userId: string = null;
  public reason: ReportReasonType = "AD";
  public reasonDetails: string = null;
}
